'use strict';

var base = require('~/product/base');
var detail = require('base:product/detail');
var cache = {
    $window: $(window),
    $body: $('body')
};

/**
 * Update availability on change event on quantity selector and on store:afterRemoveStoreSelection event.
 * If store has been selected, exit function otherwise proceed to update attributes.
 * @param {Object} element DOM Element.
 */
function updateAvailability(element) {
    var searchPID = $(element).closest('.product-detail').attr('data-pid');
    var selectorPrefix = '.product-detail[data-pid="' + searchPID + '"]';
    if ($(selectorPrefix + ' .selected-store-with-inventory').is(':visible')) {
        return;
    }

    var $productContainer = $(element).closest('.product-detail');
    if (!$productContainer.length) {
        $productContainer = $(element).closest('.modal-content').find('.product-quickview');
    }

    if ($('.bundle-items', $productContainer).length === 0) {
        base.attributeSelect($(element).find('option:selected').data('url'),
            $productContainer);
    }
}

/**
 * Registering on change event on quantity selector. If store has been selected, exist function,
 * otherwise proceed to update attributes.
 */
function availability() {
    $(document).on('change', '.quantity-select', function (e) {
        e.preventDefault();

        updateAvailability($(this));
    });

    $(document).on('store:afterRemoveStoreSelection', function (e, element) {
        e.preventDefault();
        updateAvailability(element);
    });
}

/**
 * Register custom events
 */
function customEvents() {

}

/**
 * Makes the first image in the product image carousel sticky when the user scrolls.
 * It only works on desktop devices.
 */
function stickyProductInfo() {
    let isMobile = $(window).width() <= 768;
    let mobileSelectorClasses = '.prices-add-to-cart-actions, .pdp-checkout-button, .rx-url, .rx-add-to-cart';
    let $wrapper = isMobile ? $(mobileSelectorClasses, $('.pdp-primary-info')) : $('.product-detail .carousel-container');

    if (!$wrapper.length) {
        return;
    }

    let $target = isMobile ? $('.btn:visible', $wrapper).first() : $('.carousel-gallery-container', $wrapper);
    let $siteHeader = $('.site-header');
    let initialPos = $wrapper.offset().top - $siteHeader.outerHeight();
    let initialWidth = $wrapper.width();

    if (!isMobile) {
        $target.width(initialWidth);
    }

    let handleScroll = function handleScroll($context) {
        let scrollTop = $context.scrollTop();
        let wrapperPos = $wrapper.offset().top;

        if (isMobile) {
            wrapperPos = $target.closest(mobileSelectorClasses).offset().top;
            let targetHeight = $target.outerHeight();

            if (scrollTop + cache.$window.height() < wrapperPos || scrollTop > wrapperPos) {
                $wrapper.css('min-height', targetHeight + 'px');
                $target.addClass('fixed');
            } else {
                $target.removeClass('fixed');
            }
        } else {
            initialPos = wrapperPos - $siteHeader.outerHeight();
            $target.css('width', initialWidth + 'px');

            if (scrollTop < initialPos) {
                $target.removeClass('fixed').removeClass('stick-bottom');
            } else if (scrollTop >= initialPos) {
                $target.css('top', $siteHeader.outerHeight() + 'px');
                $target.css('left', $wrapper.offset().left + 'px');
                $target.addClass('fixed').removeClass('stick-bottom');

                if ($target.outerHeight() + $target.offset().top - wrapperPos >= $wrapper.outerHeight()) {
                    $target.removeClass('fixed').addClass('stick-bottom');
                    $target.css('top', '0px');
                    $target.css('left', '0px');
                }
            }
        }
    };

    handleScroll(cache.$window);

    cache.$window.on('scroll resize', function () {
        handleScroll($(this));
    });
    cache.$window.on('load resize', function () {
        initialWidth = $wrapper.width();
        cache.$window.trigger('scroll');
    });

    cache.$body.on('product:afterAttributeSelect product:afterPrescriptionCTAsUpdated product:carouselRefreshed', function () {
        $target = isMobile ? $('.btn:visible', $wrapper).first() : $('.carousel-gallery-container', $wrapper);
        initialWidth = $wrapper.width();
        handleScroll(cache.$window);
    });

    $('.product-panel-wrapper .collapse').on('show.bs.collapse shown.bs.collapse hide.bs.collapse hidden.bs.collapse', function () {
        cache.$window.trigger('scroll');
    });

    $('.lens-technology-carousel:visible').slick('refresh');
}

var exportDetails = $.extend({}, detail, {
    availability: availability,
    init: base.init,
    stickyProductInfo: stickyProductInfo,
    customEvents: customEvents
});

module.exports = exportDetails;
